import React, { useState } from 'react';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import Input from 'components/formsy/Input';

import APICkecker from '../APICkecker';

export default function Nitro({ name, data = {} }) {
  const [apiKey, setApikey] = useState(data.apiKey || '')
  const [sid, setSid] = useState(data.sid || '')

  return <>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Api key</Label>
          <Input required
            name="apiKey"
            value={apiKey}
            onChange={setApikey}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Aff Id</Label>
          <Input required
            name="sid"
            value={sid}
            onChange={setSid}
          />
        </FormGroup>
      </Col>
    </Row>
    <APICkecker
      partner={name}
      credentials={{ sid, apiKey }}
    />
  </>
}
